import {
  ActionIcon,
  Box,
  Flex,
  Group,
  MultiSelect,
  NumberInput,
  Paper,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import React, { useEffect } from "react";
import { X } from "tabler-icons-react";
import { ListIcons } from "../../../../assets/ListIcons";

function FigureForm({ index, form, consigne }) {
  // Watch for changes in the correction_dp field
  const correctionValue = form.values.epreuves[index].correction_dp;

  // Update title when correction changes
  useEffect(() => {
    if (correctionValue && correctionValue.length > 0) {
      const selectedItem = ListIcons.find(
        (item) => `${item.name}-${item.id}` === correctionValue[0]
      );
      if (selectedItem) {
        form.setFieldValue(
          `epreuves.${index}.titre`,
          `Choisir la figure: ${selectedItem.name}`
        );
      }
    }
  }, [correctionValue, form, index]);

  return (
    <Paper mb={20} p={10} shadow="xs">
      <Group noWrap position="apart">
        <Box style={{ flex: 1 }}>
          <TextInput
            {...form.getInputProps(`epreuves.${index}.titre`)}
            placeholder="Le titre sera automatiquement mis à jour après la sélection"
            mb={10}
            disabled
          />
          <Flex gap={10}>
            <MultiSelect
              {...form.getInputProps(`epreuves.${index}.consigne`)}
              label="Selectionne les elemnts a afficher"
              placeholder="Choisir les figures"
              data={ListIcons?.map((item) => ({
                value: item?.name + "-" + item?.id,
                label: item?.icon,
              }))}
              style={{ flex: 1 }}
            />

            <MultiSelect
              {...form.getInputProps(`epreuves.${index}.correction_dp`)}
              label="Selectionne le bon element"
              placeholder="sélectionner"
              data={
                ListIcons.map((item) => ({
                  value: `${item.name}-${item.id}`,
                  label: item.icon,
                }))
              }
            />
          </Flex>
        </Box>
        <ActionIcon
          color="red"
          onClick={() => form.removeListItem(`epreuves`, index)}
        >
          <X size="1rem" />
        </ActionIcon>
      </Group>
    </Paper>
  );
}

export default FigureForm;
